



















































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { AlertMessage, ErrorMessage, NdcList, ndcListApi } from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { Emit } from '@/node_modules/nuxt-property-decorator'

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalNdcList extends ComponentVue {
  @Prop({
    type: String,
    default: ''
  })
  defaultValue!: string

  dialog: boolean = false

  ndcList: NdcList[] = []

  selectedNdcListIndex: number = -1

  selectedNdcListSecondNestIndex: number = -1

  selectedNdcListThirdNestIndex: number = -1

  get ndcListSecondNest(): NdcList[] {
    return this.ndcList[this.selectedNdcListIndex]?.groups ?? []
  }

  get ndcListThirdNest(): NdcList[] {
    return (
      this.ndcListSecondNest[this.selectedNdcListSecondNestIndex]?.groups ?? []
    )
  }

  get ndcListMaxLength(): number {
    return Math.max(
      this.ndcList.length,
      this.ndcListSecondNest.length,
      this.ndcListThirdNest.length
    )
  }

  initialize(): void {
    this.ndcList = []
    this.selectedNdcListIndex = -1
    this.selectedNdcListSecondNestIndex = -1
    this.selectedNdcListThirdNestIndex = -1
  }

  // ref参照で使用するメソッドなので外部から理解しやすい名称にラップしている
  open(): void {
    this.getNdcList()
  }

  close(): void {
    this.initialize()
    this.dialog = false
  }

  settingDefaultSelect(): void {
    this.selectedNdcListIndex = this.ndcList.findIndex(
      value =>
        value.data === this.defaultValue ||
        value.groups?.some(value =>
          value.groups?.some(value => value.data === this.defaultValue)
        )
    )
    // eslint-disable-next-line standard/computed-property-even-spacing
    this.selectedNdcListSecondNestIndex =
      this.ndcListSecondNest.findIndex(
        value =>
          value.data === this.defaultValue ||
          value.groups?.some(value => value.data === this.defaultValue)
      ) ?? -1

    // eslint-disable-next-line standard/computed-property-even-spacing
    this.selectedNdcListThirdNestIndex =
      this.ndcListThirdNest.findIndex(
        value => value.data === this.defaultValue
      ) ?? -1
  }

  existsPropertyGroups(item: NdcList): boolean {
    return item.groups !== undefined && item.groups.length > 0
  }

  // エラーが発生したらダイアログは開かない仕様
  async getNdcList(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.ndcList = await ndcListApi.getNdcList()
      this.dialog = true
      this.settingDefaultSelect()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onChangeNdcListIndex(index: number): void {
    this.selectedNdcListIndex = index
    this.selectedNdcListSecondNestIndex = -1
    this.selectedNdcListThirdNestIndex = -1
  }

  onChangeNdcListSecondNestIndex(index: number): void {
    this.selectedNdcListSecondNestIndex = index
    this.selectedNdcListThirdNestIndex = -1
  }

  onChangeNdcListThirdNestIndex(index: number): void {
    this.selectedNdcListThirdNestIndex = index
  }

  @Emit('ok')
  onClickOk(): string {
    let result: string = ''

    if (
      this.ndcListThirdNest[this.selectedNdcListThirdNestIndex]?.hasOwnProperty(
        'data'
      )
    ) {
      result =
        this.ndcListThirdNest[this.selectedNdcListThirdNestIndex].data ?? ''
    } else if (
      // eslint-disable-next-line standard/computed-property-even-spacing
      this.ndcListSecondNest[
        this.selectedNdcListSecondNestIndex
      ]?.hasOwnProperty('data')
    ) {
      result =
        this.ndcListSecondNest[this.selectedNdcListSecondNestIndex].data ?? ''
    } else if (
      this.ndcList[this.selectedNdcListIndex]?.hasOwnProperty('data')
    ) {
      result = this.ndcList[this.selectedNdcListIndex].data ?? ''
    }
    this.close()
    return result
  }
}
